var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext, useEffect, useRef, useState } from "react";
import layoutComponentsDictionary from "../layoutComponentsDictionary";
import { LayoutComponentDisplay } from "../layoutComponentDisplay";
import { useTranslation } from "react-i18next";
import { FormSettingsContext, getColorStyle, getLayoutStyle, getStyleSpacing, scrollToEl, } from "../../utils";
import { RecordContext } from "../recordContext";
import { FormComponentButtons } from "../../formComponentButtons";
import "./settings";
import "./list";
import { LayoutButtons } from "../../layoutButtons";
import { BasicComponents } from "../../basicComponent";
/**
 * <b>Composants de rendu des dispositions d'affichage `layout-rows`</b>
 *
 * @param param0
 */
export function LayoutPanels(_a) {
    var _b, _c;
    var module = _a.module, viewType = _a.viewType, fieldDefs = _a.fieldDefs, record = _a.record, fetchedRecord = _a.fetchedRecord, layouts = _a.layouts, onHandleUpdate = _a.onHandleUpdate, validations = _a.validations, isStudioField = _a.isStudioField, isSelected = _a.isSelected, layoutParent = _a.layoutParent, viewScreen = _a.viewScreen;
    var _d = useState(true), open = _d[0], setOpen = _d[1];
    var _e = useContext(FormSettingsContext), settings = _e.settings, editedSettings = _e.editedSettings;
    var set = settings || {};
    var current = set.currentComponent || {};
    var s = current.settings || {};
    var panelTitle = layouts[0].settings.label || "";
    var t = useTranslation(["common", module]).t;
    var editedRecord = useContext(RecordContext);
    var updateRecord = function (edited) {
        onHandleUpdate && onHandleUpdate(edited);
    };
    // Css pour le studio
    var borderStyle = isStudioField
        ? "border border-gray-500 border-dashed hover:border-red-500"
        : "";
    var refs = useRef(null);
    var onClickComponent = function (e) {
        e.stopPropagation();
        editedSettings(__assign(__assign({}, settings), { selected: layouts && layouts[0].id, parentId: layoutParent }));
        scrollToEl(refs && (refs === null || refs === void 0 ? void 0 : refs.current));
    };
    // si composant séléctionné
    useEffect(function () {
        isStudioField && !open && setOpen(true);
        isStudioField &&
            settings.selected === layouts[0].id &&
            editedSettings(__assign(__assign({}, settings), { target: layouts && layouts[0].id, type: layouts && layouts[0].type, component: layouts && layouts[0].components, selected: layouts && layouts[0].id, parentId: layoutParent, currentComponent: layouts[0] }));
    }, [isStudioField && settings.selected]);
    // Styles
    var _f = useState(), styles = _f[0], setStyles = _f[1];
    var _g = useState(""), labelColor = _g[0], setLabelColor = _g[1];
    useEffect(function () {
        var _a, _b;
        var colorStyle = getColorStyle(((_a = layouts[0].settings) === null || _a === void 0 ? void 0 : _a.styles) || {});
        setLabelColor(colorStyle.color);
        delete colorStyle.color;
        var spacingStyle = (layouts[0].settings && __assign(__assign({}, getStyleSpacing(((_b = layouts[0].settings) === null || _b === void 0 ? void 0 : _b.styles) || {})), colorStyle)) ||
            "";
        setStyles(__assign({}, spacingStyle));
    }, [(_c = (_b = layouts[0]) === null || _b === void 0 ? void 0 : _b.settings) === null || _c === void 0 ? void 0 : _c.styles]);
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ style: styles, ref: function (el) {
                    if (el)
                        refs.current = el;
                }, id: layouts[0].id }, { children: _jsxs("div", __assign({ className: "w-full ".concat(borderStyle), onClick: function (v) {
                        isStudioField && onClickComponent(v);
                    }, style: getLayoutStyle(isSelected === layouts[0].id) }, { children: [_jsx("div", __assign({ className: "w-full bg-[var(--colors-subpanel-bg)] py-4 text-[var(--colors-subpanel)]" }, { children: _jsx("button", __assign({ onClick: function (e) {
                                    e.stopPropagation();
                                    setOpen(!open);
                                } }, { children: _jsxs("span", __assign({ className: "flex flex-row", style: { color: labelColor } }, { children: [open ? (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M19.5 8.25l-7.5 7.5-7.5-7.5" }) }))) : (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", "stroke-width": "1.5", stroke: "currentColor", className: "w-6" }, { children: _jsx("path", { "stroke-linecap": "round", "stroke-linejoin": "round", d: "M4.5 15.75l7.5-7.5 7.5 7.5" }) }))), _jsx("label", __assign({ className: "font-bold pl-2 pt-1", style: { color: labelColor } }, { children: (function () {
                                                var key = typeof panelTitle === "string"
                                                    ? panelTitle.toUpperCase()
                                                    : panelTitle;
                                                var translationModule = t(key, { ns: module });
                                                return translationModule === key
                                                    ? t("app.".concat(panelTitle), { ns: "common" })
                                                    : translationModule;
                                            })() }))] })) })) })), _jsx(_Fragment, { children: open &&
                                layouts[0].components.map(function (component, index) {
                                    var componentType = component.type || "";
                                    if ((component && componentType === "etc-field") ||
                                        componentType === "header") {
                                        return (_jsx("div", { children: _jsx(BasicComponents, { record: editedRecord, layoutType: componentType, meta: component || [], fieldDefs: fieldDefs, validations: validations, isStudioField: isStudioField, isSelected: isSelected, layoutParent: layouts[0], onHandleUpdate: updateRecord, viewScreen: viewScreen, moduleName: module || "Accounts" }) }));
                                    }
                                    //Defaul display a layout component
                                    return (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "relative" }, { children: _jsx(LayoutComponentDisplay, { module: module, viewType: viewType, fieldDefs: fieldDefs, record: editedRecord, fetchedRecord: fetchedRecord, layouts: component, onHandleUpdate: updateRecord, validations: validations, isStudioField: isStudioField, isSelected: isSelected, layoutParent: layouts[0], viewScreen: viewScreen }, index) })) }));
                                }) })] })) })), isStudioField && (_jsxs(_Fragment, { children: [_jsx(FormComponentButtons, { parentId: layoutParent, meta: (settings && settings) || [], isLayout: true, isSelected: isSelected === layouts[0].id }), _jsx(LayoutButtons, { parentId: layoutParent, component: layouts[0] || [], isLayout: true })] }))] }));
}
layoutComponentsDictionary.registerLayoutComponent("panel", LayoutPanels);
